// Team access (Olene Phase 7b, backend/acting.py). While the active company is one someone else
// shared with this person, every authenticated API request says so with ?olene_company=<id>, and
// the API works as that company's owner, limited to it. CompanyProvider keeps this current.
let sharedCompanyId = null;

export function setSharedCompany(id) {
  sharedCompanyId = id || null;
}

export function withSharedCompany(url) {
  if (!sharedCompanyId) return url;
  const u = new URL(url);
  if (!u.searchParams.has("olene_company")) u.searchParams.set("olene_company", sharedCompanyId);
  return u.toString();
}
